import React from 'react';
import { Box, Typography } from '@mui/material';
import { linkProps } from '../../../utils/appLink';

export const SEO_SUBJECT_EXPLAINER_BLUE = '#162F3B';
export const SEO_SUBJECT_EXPLAINER_YELLOW = '#C7CA00';
export const SEO_SUBJECT_EXPLAINER_READ_MORE = 'Read more';

export const SeoSubjectExplainerCard = ({ card, isDesktop, cardSx = {} }) => {
  const title = card?.title || '';
  const body = card?.body || '';
  const href = card?.link || undefined;
  const readMoreLabel = card?.linkLabel || SEO_SUBJECT_EXPLAINER_READ_MORE;

  return (
    <Box
      sx={{
        width: isDesktop ? '596px' : '100%',
        height: isDesktop ? '292px' : 'auto',
        backgroundColor: '#FFFFFF',
        borderRadius: isDesktop ? '40px' : '28px',
        boxShadow: '0px 1px 2px 0px #A2ACB133, 0px 12px 24px -4px #162F3B1F',
        boxSizing: 'border-box',
        p: isDesktop ? '40px 80px' : '24px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: isDesktop ? '40px' : '20px',
        ...cardSx,
      }}
    >
      <Box>
        <Typography
          component="h3"
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: isDesktop ? '1.5rem' : '1.5rem',
            lineHeight: isDesktop ? '1.75rem' : '1.875rem',
            letterSpacing: isDesktop ? '-0.03em' : '-0.03em',
            color: SEO_SUBJECT_EXPLAINER_BLUE,
            mb: isDesktop ? '24px' : '16px',
            whiteSpace: 'pre-line',
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontFamily: '"Body/Body/Font Family", Inter, sans-serif',
            fontWeight: 400,
            fontSize: isDesktop ? '1rem' : '1rem',
            lineHeight: isDesktop ? '1.5rem' : '1.5rem',
            letterSpacing: '-0.002em',
            color: SEO_SUBJECT_EXPLAINER_BLUE,
            whiteSpace: 'pre-line',
            maxWidth: isDesktop ? '436px' : '100%',
          }}
        >
          {body}
        </Typography>
      </Box>

      {href ? (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Typography
            {...linkProps(href)}
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 600,
              fontSize: isDesktop ? '1.125rem' : '1rem',
              lineHeight: isDesktop ? '1.5rem' : '1.25rem',
              letterSpacing: '-0.02em',
              color: SEO_SUBJECT_EXPLAINER_BLUE,
              textDecoration: 'none',
              '&:hover': {
                color: '#9EA900',
                textDecoration: 'underline',
              },
            }}
          >
            {readMoreLabel}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};
